import { useState } from 'react'
import { NavLink, Navigate, Outlet, useLocation } from 'react-router-dom'
import { useAdminAuth } from '../AuthProvider'
import { useAdminFixturesFromQuery } from '../fixtures'
import { adminNav } from '../types'
import { ThemeToggle } from '../../components/ui/ThemeToggle'
import { PanelNavIcon } from '../../shared/PanelNavIcons'
import { BrandLogo } from '../../shared/BrandLogo'

export function AdminLayout() {
  const { isAuthenticated, logout, admin } = useAdminAuth()
  const fixtures = useAdminFixturesFromQuery()
  const location = useLocation()
  const [drawerOpen, setDrawerOpen] = useState(false)

  if (!isAuthenticated && !fixtures) {
    return <Navigate to="/admin/login" replace state={{ from: location.pathname }} />
  }

  return (
    <div className={`ap-shell ap-shell--admin ${drawerOpen ? 'is-drawer-open' : ''}`}>
      <a className="skip-link" href="#admin-main">
        Skip to content
      </a>

      <button
        type="button"
        className="ap-menu-btn"
        aria-expanded={drawerOpen}
        aria-controls="admin-drawer"
        onClick={() => setDrawerOpen((v) => !v)}
      >
        <span className="ap-menu-btn__bars" aria-hidden="true" />
        Menu
      </button>

      <div
        className="ap-drawer-backdrop"
        hidden={!drawerOpen}
        onClick={() => setDrawerOpen(false)}
      />

      <aside id="admin-drawer" className="ap-sidebar" aria-label="Admin navigation">
        <div className="ap-sidebar__brand">
          <BrandLogo tone="light" />
          <span className="ap-sidebar__role">Master Admin</span>
        </div>
        <p className="ap-sidebar__section">Operations</p>
        <nav className="ap-sidebar__nav">
          {adminNav.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={'end' in item ? item.end : false}
              onClick={() => setDrawerOpen(false)}
              className={({ isActive }) => (isActive ? 'is-active' : undefined)}
            >
              <PanelNavIcon name={item.icon} />
              <span>{item.label}</span>
            </NavLink>
          ))}
        </nav>
        <div className="ap-sidebar__foot">
          {!fixtures ? (
            <button type="button" className="pp-btn pp-btn--secondary pp-btn--sm" onClick={logout}>
              Logout
            </button>
          ) : null}
        </div>
      </aside>

      <div className="ap-main-wrap">
        <header className="ap-topbar">
          <div>
            <p className="ap-topbar__eyebrow">Operations console</p>
            <strong className="ap-topbar__title">
              {fixtures ? 'Fixture preview' : admin?.displayName || admin?.email || 'Admin'}
            </strong>
          </div>
          <div className="ap-topbar__actions">
            {fixtures ? <span className="cp-chip cp-chip--warn">Preview fixtures</span> : null}
            <span className="ap-topbar__badge">Admin</span>
            <ThemeToggle />
          </div>
        </header>
        <main id="admin-main" className="ap-main">
          <Outlet />
        </main>
      </div>
    </div>
  )
}
